/**
 * Blog slider: mirrors the active blog-slide main image
 * into .blog-slider-section__copy-slide-image (sibling before swiper-container). Only runs when
 * that host exists under .blog-slider-section.
 */
(function () {
  var INCOMING_CLASS = 'blog-slider-section__copy-slide-image-incoming';

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function getCopyImageTargetWidth(copyRoot) {
    var rootWidth = (copyRoot && copyRoot.clientWidth) || 0;
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
    var cssWidth = Math.max(rootWidth, viewportWidth, 1);
    var dpr = window.devicePixelRatio || 1;
    return Math.round(clamp(cssWidth * dpr, 320, 2400));
  }

  function withShopifyWidth(url, targetWidth) {
    if (!url || typeof url !== 'string') return url;
    if (url.indexOf('//cdn.shopify.com/') === -1 && url.indexOf('://cdn.shopify.com/') === -1) return url;
    try {
      var parsed = new URL(url, window.location.origin);
      parsed.searchParams.set('width', String(targetWidth));
      return parsed.toString();
    } catch (e) {
      return url;
    }
  }

  function applyImageSizingFilter(copyRoot) {
    if (!copyRoot) return;
    var targetWidth = getCopyImageTargetWidth(copyRoot);
    var scope =
      copyRoot.querySelector(':scope > .blog-slide-image') ||
      copyRoot.querySelector('.' + INCOMING_CLASS + ' .blog-slide-image') ||
      copyRoot;
    var copyImg = scope.querySelector('img');
    if (!copyImg) return;

    copyImg.setAttribute('sizes', targetWidth + 'px');

    var picture = scope.querySelector('picture');
    if (picture) {
      picture.querySelectorAll('source').forEach(function (sourceEl) {
        sourceEl.setAttribute('sizes', targetWidth + 'px');
      });
    }

    if (!copyImg.getAttribute('srcset') && copyImg.hasAttribute('src')) {
      copyImg.setAttribute('src', withShopifyWidth(copyImg.getAttribute('src'), targetWidth));
    }
  }

  function getTransitionMs(swiperInstance, swiperEl) {
    if (swiperInstance && swiperInstance.params && swiperInstance.params.speed != null) {
      var fromParams = Number(swiperInstance.params.speed);
      if (!isNaN(fromParams) && fromParams >= 0) return fromParams;
    }
    var attr = swiperEl && swiperEl.getAttribute('speed');
    var fromAttr = Number(attr);
    if (!isNaN(fromAttr) && fromAttr >= 0) return fromAttr;
    return 300;
  }

  function getSlideKey(swiperInstance) {
    if (!swiperInstance) return null;
    if (swiperInstance.realIndex != null) return swiperInstance.realIndex;
    return swiperInstance.activeIndex;
  }

  function getActiveSlide(swiperInstance) {
    if (!swiperInstance || !swiperInstance.slides) return null;
    var idx = swiperInstance.activeIndex;
    if (idx != null && swiperInstance.slides[idx]) return swiperInstance.slides[idx];
    var host = swiperInstance.el || swiperInstance.hostEl;
    if (!host) return null;
    return (
      host.querySelector('swiper-slide.swiper-slide-active') ||
      host.querySelector('.swiper-slide-active') ||
      host.querySelector('swiper-slide.swiper-slide-duplicate-active')
    );
  }

  function syncImageAttributes(destImg, srcImg) {
    if (!destImg || !srcImg) return;
    for (var j = destImg.attributes.length - 1; j >= 0; j--) {
      var n = destImg.attributes[j].name;
      if (!srcImg.hasAttribute(n)) destImg.removeAttribute(n);
    }
    for (var i = 0; i < srcImg.attributes.length; i++) {
      var a = srcImg.attributes[i];
      destImg.setAttribute(a.name, a.value);
    }
  }

  function syncPictureFromSource(destPicture, srcPicture) {
    if (!destPicture || !srcPicture) return;
    var destImg = destPicture.querySelector('img');
    var srcImg = srcPicture.querySelector('img');

    destPicture.querySelectorAll('source').forEach(function (s) {
      s.remove();
    });
    srcPicture.querySelectorAll('source').forEach(function (s) {
      destPicture.insertBefore(s.cloneNode(true), destImg || null);
    });

    if (destImg && srcImg) syncImageAttributes(destImg, srcImg);

    destPicture.className = srcPicture.className;
    if (srcPicture.hasAttribute('data-iesrc')) {
      destPicture.setAttribute('data-iesrc', srcPicture.getAttribute('data-iesrc'));
    } else {
      destPicture.removeAttribute('data-iesrc');
    }
    if (srcPicture.hasAttribute('data-alt')) {
      destPicture.setAttribute('data-alt', srcPicture.getAttribute('data-alt'));
    } else {
      destPicture.removeAttribute('data-alt');
    }
    destPicture.removeAttribute('data-loaded');
  }

  function getSourceFromSlide(activeSlide) {
    if (!activeSlide) return null;
    var slideInner = activeSlide.querySelector('.blog-slide');
    if (!slideInner) return null;
    return slideInner.querySelector('.blog-slide-image');
  }

  function getBaseContainer(copyRoot) {
    return copyRoot && copyRoot.querySelector(':scope > .blog-slide-image');
  }

  function removeIncomingLayers(copyRoot) {
    if (!copyRoot) return;
    copyRoot.querySelectorAll('.' + INCOMING_CLASS).forEach(function (el) {
      el.remove();
    });
  }

  function fillCopyFromSlideElement(activeSlide, copyRoot) {
    if (!activeSlide || !copyRoot) return;
    var source = getSourceFromSlide(activeSlide);
    if (!source) {
      removeIncomingLayers(copyRoot);
      if (!getBaseContainer(copyRoot)) copyRoot.replaceChildren();
      return;
    }

    var srcPicture = source.querySelector('picture');
    var srcImg = source.querySelector('img');
    if (!srcPicture && !srcImg) {
      removeIncomingLayers(copyRoot);
      if (!getBaseContainer(copyRoot)) copyRoot.replaceChildren();
      return;
    }

    var destContainer = getBaseContainer(copyRoot);
    var destPicture = destContainer && destContainer.querySelector('picture');
    var destImg = destContainer && destContainer.querySelector('img');

    if (srcPicture) {
      if (!destPicture) {
        removeIncomingLayers(copyRoot);
        copyRoot.replaceChildren();
        copyRoot.appendChild(source.cloneNode(true));
        applyImageSizingFilter(copyRoot);
        return;
      }
      syncPictureFromSource(destPicture, srcPicture);
      applyImageSizingFilter(copyRoot);
      return;
    }

    if (!destImg) {
      removeIncomingLayers(copyRoot);
      copyRoot.replaceChildren();
      copyRoot.appendChild(source.cloneNode(true));
      applyImageSizingFilter(copyRoot);
      return;
    }
    syncImageAttributes(destImg, srcImg);
    applyImageSizingFilter(copyRoot);
  }

  function syncCopyFromSwiperDom(swiperEl, copyRoot) {
    if (!swiperEl || !copyRoot) return;
    var active =
      swiperEl.querySelector('swiper-slide.swiper-slide-active') ||
      swiperEl.querySelector('swiper-slide.swiper-slide-duplicate-active') ||
      swiperEl.querySelector('swiper-slide');
    fillCopyFromSlideElement(active, copyRoot);
  }

  function getCopyRootForSwiper(swiperEl) {
    var wrapper = swiperEl.parentElement;
    if (!wrapper || !wrapper.classList.contains('swiper-wrapper__custom')) return null;
    var section = wrapper.closest('.blog-slider-section');
    if (!section) return null;

    var copy = wrapper.querySelector(':scope > [data-copy-slide-image]');
    if (copy) return copy;

    return section.querySelector('.blog-slider-section__copy-slide-image');
  }

  function promoteIncomingIfAny(copyRoot) {
    if (!copyRoot) return;
    var incoming = copyRoot.querySelector('.' + INCOMING_CLASS);
    if (!incoming) return;

    var srcPicture = incoming.querySelector('picture');
    var srcImg = incoming.querySelector('img');
    var destContainer = getBaseContainer(copyRoot);
    var destPicture = destContainer && destContainer.querySelector('picture');
    var destImg = destContainer && destContainer.querySelector('img');

    if (srcPicture && destPicture) {
      syncPictureFromSource(destPicture, srcPicture);
      applyImageSizingFilter(copyRoot);
    } else if (srcImg && destImg && !destPicture) {
      syncImageAttributes(destImg, srcImg);
      applyImageSizingFilter(copyRoot);
    } else {
      var cloned = incoming.querySelector('.blog-slide-image');
      if (cloned) {
        copyRoot.querySelectorAll(':scope > .blog-slide-image').forEach(function (el) {
          el.remove();
        });
        copyRoot.insertBefore(cloned.cloneNode(true), incoming);
        applyImageSizingFilter(copyRoot);
      }
    }
    incoming.remove();
  }

  function clearCrossfadeTimer(copyRoot) {
    if (!copyRoot || !copyRoot._copyImageFade) return;
    if (copyRoot._copyImageFade.timer) clearTimeout(copyRoot._copyImageFade.timer);
    copyRoot._copyImageFade = null;
  }

  function commitCopyToActive(swiperInstance, copyRoot) {
    if (!swiperInstance || !copyRoot) return;
    clearCrossfadeTimer(copyRoot);
    fillCopyFromSlideElement(getActiveSlide(swiperInstance), copyRoot);
    removeIncomingLayers(copyRoot);
  }

  function sourceHasMedia(source) {
    return !!(source && (source.querySelector('picture') || source.querySelector('img')));
  }

  function hasExistingCopyMedia(copyRoot) {
    var base = getBaseContainer(copyRoot);
    return !!(base && (base.querySelector('picture') || base.querySelector('img')));
  }

  /**
   * Crossfade: keep old image visible, fade new layer in over Swiper speed,
   * then promote it. Avoids blank/dark gap from fade-out-then-in.
   */
  function syncCopyFromSlideWithFade(swiperInstance, copyRoot, swiperEl, animate) {
    if (!swiperInstance || !copyRoot) return;

    var activeSlide = getActiveSlide(swiperInstance);
    if (!activeSlide) return;

    var source = getSourceFromSlide(activeSlide);
    var hasExisting = hasExistingCopyMedia(copyRoot);
    var slideKey = getSlideKey(swiperInstance);

    if (!animate || !hasExisting || !sourceHasMedia(source)) {
      clearCrossfadeTimer(copyRoot);
      promoteIncomingIfAny(copyRoot);
      fillCopyFromSlideElement(activeSlide, copyRoot);
      copyRoot._copySyncedKey = slideKey;
      return;
    }

    if (copyRoot._copyImageFade && copyRoot._copyImageFade.key === slideKey) return;
    if (copyRoot._copySyncedKey === slideKey && !copyRoot.querySelector('.' + INCOMING_CLASS)) {
      return;
    }

    clearCrossfadeTimer(copyRoot);
    promoteIncomingIfAny(copyRoot);

    var duration = getTransitionMs(swiperInstance, swiperEl);
    copyRoot.style.setProperty('--copy-image-fade-ms', duration + 'ms');

    var incoming = document.createElement('div');
    incoming.className = INCOMING_CLASS;
    incoming.setAttribute('data-slide-key', String(slideKey));
    incoming.appendChild(source.cloneNode(true));
    copyRoot.appendChild(incoming);
    applyImageSizingFilter(incoming);
    copyRoot._copySyncedKey = slideKey;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (!incoming.isConnected) return;
        incoming.classList.add('is-visible');
      });
    });

    copyRoot._copyImageFade = {
      key: slideKey,
      timer: setTimeout(function () {
        var latest = swiperEl.swiper || swiperInstance;
        fillCopyFromSlideElement(getActiveSlide(latest), copyRoot);
        if (incoming.isConnected) incoming.remove();
        copyRoot._copyImageFade = null;
        copyRoot._copySyncedKey = getSlideKey(latest);
      }, duration + 20)
    };
  }

  function scheduleSyncWhenSwiperReady(swiperEl, copyRoot) {
    var attempts = 0;
    var max = 80;

    function tick() {
      if (swiperEl.swiper) {
        syncCopyFromSlideWithFade(swiperEl.swiper, copyRoot, swiperEl, false);
        return;
      }
      if (++attempts < max) {
        requestAnimationFrame(tick);
      } else {
        syncCopyFromSwiperDom(swiperEl, copyRoot);
      }
    }

    requestAnimationFrame(tick);
  }

  function bindBlogSliderSwiper(swiperEl) {
    var copyRoot = getCopyRootForSwiper(swiperEl);
    if (!copyRoot) return;

    function runFromInstance(animate) {
      var inst = swiperEl.swiper;
      if (inst) syncCopyFromSlideWithFade(inst, copyRoot, swiperEl, !!animate);
    }

    function getInst(e) {
      return (e && e.detail && e.detail[0]) || swiperEl.swiper;
    }

    function onSlideTransition(e) {
      var inst = getInst(e);
      if (!inst) return;
      syncCopyFromSlideWithFade(inst, copyRoot, swiperEl, true);
    }

    function onTransitionSettled(e) {
      var inst = getInst(e);
      if (!inst) return;
      var key = getSlideKey(inst);
      var incoming = copyRoot.querySelector('.' + INCOMING_CLASS);
      if (incoming && incoming.getAttribute('data-slide-key') === String(key) && incoming.classList.contains('is-visible')) {
        clearCrossfadeTimer(copyRoot);
        fillCopyFromSlideElement(getActiveSlide(inst), copyRoot);
        incoming.remove();
        copyRoot._copySyncedKey = key;
        return;
      }
      commitCopyToActive(inst, copyRoot);
      copyRoot._copySyncedKey = key;
    }

    syncCopyFromSwiperDom(swiperEl, copyRoot);

    swiperEl.addEventListener(
      'swiper:init',
      function () {
        runFromInstance(false);
      },
      { once: true }
    );

    swiperEl.addEventListener('swiperslidechangetransitionstart', onSlideTransition);
    swiperEl.addEventListener('swiperslidechange', onSlideTransition);
    swiperEl.addEventListener('swiperrealindexchange', onSlideTransition);
    swiperEl.addEventListener('swiperslidechangetransitionend', onTransitionSettled);
    swiperEl.addEventListener('swipertransitionend', onTransitionSettled);
    swiperEl.addEventListener('swipertouchend', function (e) {
      var inst = getInst(e);
      if (!inst) return;
      requestAnimationFrame(function () {
        var current = swiperEl.swiper || inst;
        if (!current) return;
        if (getSlideKey(current) !== copyRoot._copySyncedKey) {
          syncCopyFromSlideWithFade(current, copyRoot, swiperEl, true);
        }
      });
    });

    if (swiperEl.swiper) {
      runFromInstance(false);
    } else {
      scheduleSyncWhenSwiperReady(swiperEl, copyRoot);
    }
  }

  function init() {
    document.querySelectorAll('.blog-slider-section swiper-container').forEach(bindBlogSliderSwiper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', function () {
    document.querySelectorAll('.blog-slider-section swiper-container').forEach(function (swiperEl) {
      var copyRoot = getCopyRootForSwiper(swiperEl);
      if (!copyRoot) return;
      if (swiperEl.swiper) syncCopyFromSlideWithFade(swiperEl.swiper, copyRoot, swiperEl, false);
      else syncCopyFromSwiperDom(swiperEl, copyRoot);
    });
  });
})();
